import _round from "lodash/round";

export const round = (number: number, precision?: number) => {
  return _round(number, precision);
};
